import IconBase, {
    Example as IconBaseExample,
    type TIconBaseProps,
    type TIconBaseRef,
} from '@atlas/uicorn/lib/Icon/IconBase';
import * as React from 'react';
import styled from 'styled-components';

const ChevronIcon = React.memo(
    React.forwardRef(function ChevronIcon(
        props: TChevronIconProps,
        ref: React.ForwardedRef<TIconBaseRef>,
    ): React.ReactElement {
        const { dir = 'right', ...elementProps } = props;
        return (
            <SIconBase aria-label="Chevron" {...elementProps} $dir={dir} ref={ref}>
                <path d="M8.12776 5.74547C7.77533 6.11855 7.77501 6.70175 8.12704 7.07521L11.8266 11L8.12704 14.9248C7.77501 15.2982 7.77533 15.8815 8.12776 16.2545C8.51004 16.6592 9.15393 16.6592 9.53621 16.2545L13.8513 11.6867C14.2154 11.3013 14.2154 10.6987 13.8513 10.3133L9.5362 5.74547C9.15393 5.3408 8.51004 5.3408 8.12776 5.74547Z" />
            </SIconBase>
        );
    }),
);

export default ChevronIcon;

// #region Styles

const SIconBase = styled(IconBase)<{ $dir: TChevronIconDirection }>`
    path {
        transition: rotate 0.2s ease;
        transform-origin: center;
        rotate: ${(p) => (p.$dir === 'left' ? '180deg' : p.$dir === 'up' ? '-90deg' : p.$dir === 'down' ? '90deg' : 0)};
    }
`;

// #endregion

// #region Types

export type TChevronIconDirection = 'right' | 'left' | 'up' | 'down';

export type TChevronIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>> & {
        dir?: TChevronIconDirection;
    };

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function'
        ? () => <ChevronIcon />
        : {
              ...IconBaseExample,
              render: ChevronIcon,
              controls: { dir: ['right', 'left', 'up', 'down'], ...IconBaseExample.controls },
          };

// #endregion
